import { notify } from '../model/datatype';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

export const CalendarModal = (props: notify) => {
  let { t } = useTranslation();
  const text = props.btnText ? props.btnText : 'ตกลง';
  const width = '100%';
  const type = props.type ? props.type : 'text';
  const btnConfirm = props.btnConfirm ? props.btnConfirm : 'no';
  const [load, setLoad] = useState(true);
  function ramdomNumber() {
    return Math.floor(Math.random() * 90000) + 10000;
  }

  // Display a base64 URL inside an iframe in another window.
  function Base64ToImage(base64Image: any) {
    var newTab = window.open();
    var css = '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous">';
    newTab?.document.writeln('<head>' + css + '</head>');
    newTab?.document.writeln('<iframe src="' + base64Image + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:95%;"></iframe>');
    newTab?.document.writeln(
      '<div style="height: 100px;">' +
      '<div class="fixed-bottom d-flex justify-content-center">' +
      '<button type="button" class="btn btn-primary btn-lg btn-start" onclick="window.open(\'\',\'_self\', \'\'); window.close();" style="width: 100%;height: 140px;font-size: 44px;background: #ea5455;">'+text+'</button>' +
      '</div>' +
      '</div>'
    );
    newTab?.document.close();
  }

  function openBase64InNewTab(data: any, mimeType: any) {
    var byteCharacters = atob(data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: mimeType + ';base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }

  useEffect(() => {
    // if (props.body) {
    //   setLoad(false);
    // }
  }, []);

  return (
    <Modal
      id="nofitfyModal"
      onExiting={props.onExiting}
      show={props.showModal}
      onHide={props.handleContinue}
      backdrop={props.backdrop}
      keyboard={props.keyboard}
      centered
      style={props.Style}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      {type === 'text' ? (
        <Modal.Body className="modal-alert-body text-center p-4">
          {props.body}
        </Modal.Body>
      ) : (
        ''
      )}
      {type === 'images' ? (
        <Modal.Body className="modal-alert-body text-center">
          {/* <a href={props.body} onClick={() => openBase64InNewTab(props.body, "image/jpg")}> */}
          {/* <a href={props.body} target='_blank' download="calendar.jpg"> */}
          <a href={props.body} onClick={() => Base64ToImage(props.body)}>
            <img title='image'
              src={props.body}
              width={width}
              onLoad={() => setLoad(false)}
            />
          </a>
        </Modal.Body>
      ) : (
        ''
      )}
      <Modal.Footer className="modal-alert-footer">
        {btnConfirm === 'yes' ? (
          <>
            <Button
              variant="success"
              onClick={props.confirmFunc}
              style={{ width: 100 }}
            >
              {t('btn_confirm')}
            </Button>
            <Button
              variant="danger btn-no"
              onClick={props.onHide}
              style={{ width: 100 }}
            >
              {t('btn_cancel')}
            </Button>
          </>
        ) : (
          ''
        )}

        {btnConfirm === 'no' ? (
          <Button
            variant="primary"
            onClick={props.onHide}
            style={{ width: 100 }}
          >
            {text}
          </Button>
        ) : (
          ''
        )}
      </Modal.Footer>
    </Modal>
  );
};
